import styled, { css } from 'styled-components/macro'
import { theme, ifProp, switchProp } from 'styled-tools'
import { em, rem } from '../../utils/styles'

const fontSize = switchProp('size', {
  small: em(26.6)
}, em(36))

const margin = switchProp('size', {
  small: rem(12)
}, rem(36))

const align = switchProp('align', {
  center: css`text-align: center;`,
  right: css`text-align: right;`
})

const leader = ifProp('leader', css`margin-top: ${margin};`)
const trailer = ifProp('trailer', css`margin-bottom: ${margin};`)

const H1 = styled.h1`
  margin: 0;
  ${leader}
  ${trailer}
  ${align}
  font-weight: ${theme('fontWeights.bold')};
  font-size: ${fontSize};
  line-height: 1.2;
`

export default H1
